import { PRODUCT_PREPAY_CARDS } from '@/constants/products';
import { getRateChanges } from '@/graphql/queries/shared/rate-change';
import lang from '@/lang/middleware/products/banking/prepay-cards';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('rateChanges.description');
  const title = store.$i18n.t('rateChanges.title');
  store.commit('jumbotron/SET_JUMBOTRON', {
    subtitle: store.$i18n.t('rateChanges.jumbotron.subtitle'),
    title,
    type: 'generic'
  });
  store.commit('pageContent/setHead', { description, title });
  await $apolloQuery(getRateChanges, { product: PRODUCT_PREPAY_CARDS }).then(r => {
    store.commit('rateChanges/setMeta', r.data);
    store.commit('rateChanges/set', r.changes);
    store.commit('utils/setPagination', r.meta.pagination);
  });
};
